import React from 'react'

const Product = React.lazy(() => import('pages/Product/Product'));
const ProductAdd = React.lazy(() => import('pages/Product/ProductAdd'));
const ProductEdit = React.lazy(() => import('pages/Product/ProductEdit'));
const ProductDetail = React.lazy(() => import('pages/Product/ProductDetail'));
const ProductCopy = React.lazy(() => import('pages/Product/ProductCopy'));
const ProductBarcode = React.lazy(() => import('pages/Product/ProductBarcode'));

const ProductRoutes = [
    {
        path: '/products',
        exact: true,
        name: 'Danh sách sản phẩm',
        function: 'MD_PRODUCT_VIEW',
        component: Product,
    },
    {
        path: '/products/add',
        exact: true,
        name: 'Thêm mới',
        function: 'MD_PRODUCT_ADD',
        component: ProductAdd,
    },
    {
        path: '/products/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'MD_PRODUCT_VIEW',
        component: ProductDetail,
    },
    {
        path: '/products/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'MD_PRODUCT_EDIT',
        component: ProductEdit,
    },
    {
        path: '/products/copy/:id',
        exact: true,
        name: 'Sao chép',
        function: 'MD_PRODUCT_ADD',
        component: ProductCopy,
    },
    {
        path: '/products/barcode',
        exact: true,
        name: 'In mã vạch',
        function: 'MD_PRODUCT_ADD',
        component: ProductBarcode,
    },
    {
        path: '/products/barcode-list',
        exact: true,
        name: 'In barcode bất kỳ',
        function: 'MD_PRODUCT_PRINTBARCODE',
        component: ProductBarcode,
    },
    {
        path: '/products/barcode-product',
        exact: true,
        name: 'In barcode theo sản phẩm',
        function: 'MD_PRODUCT_PRINTBARCODE',
        component: ProductBarcode,
    },
    {
        path: '/products/barcode-product-list',
        exact: true,
        name: 'Lịch sử barcode đã in theo sản phẩm',
        function: 'MD_PRODUCT_PRINTBARCODE',
        component: ProductBarcode,
    },
]

export default ProductRoutes
